// extracted by mini-css-extract-plugin
export default {"active":"RequestTable_active__qsfES","inactive":"RequestTable_inactive__GZ0vE","revoked":"RequestTable_revoked__osJBy"};